<template>
    <div class="shixinren">
      <div class="table-box">
        <h3 class="title">恶意逃废债人员信息公示</h3>
        <el-table
          header-cell-class-name="header"
          :data="shixindata"
          border
          style="width: 100%">



          <el-table-column
            align="center"
            prop="name"
            label="姓名"

          >

          </el-table-column>

          <el-table-column
            align="center"
            prop="id"
            label="身份证号码"

          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号"

          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="area"
            label="地区"

          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="pingtai"
            label="申请平台"

          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="date"
            label="借款日期"

          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="benjin"
            label="借款本金"

          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="weihuan"
            label="剩余未还金额"

          >
          </el-table-column>

        </el-table>
        <div class="pagination">
          <el-row>
            <el-col :span="24"><el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout=" prev, pager, next, slot, jumper"
              :page-count="pageCount"
              :page-size="pageSize"
              :total="total">
              <span class="el-pagination__jump"> 共{{pageCount}}页</span>

            </el-pagination>
            </el-col>
            <el-col :span="3">
              <!--<el-button size="small" type="primary" @click="">确定</el-button>-->
            </el-col>
          </el-row>


        </div>
      </div>
    </div>
</template>

<script>
import borrowBanner from '../borrowGuide/borrowBanner'
import borrowCondition from '../borrowGuide/borrowCondition'
import borrowButtonArea from '../borrowGuide/borrowButtonArea'
import shixinren from "../../utils/shixinren";
import shixinren2 from "../../utils/shixinren2";
export default {
    components: { borrowBanner, borrowCondition, borrowButtonArea},
    data() {
        return {
          shixindata:[],
	        pageCount:0,
	        total:0,
	        pageSize:10,
	        currentPage:1
        }
    },
    created() {
	    this.handleCurrentChange(1)
    },
	methods:{
	    handleCurrentChange(page){
		    this.currentPage=page
		    let shixinrenObj = page>50 ?shixinren2 : shixinren
		    const pageData = shixinrenObj.cutData(page,this.pageSize)
        console.log(pageData)
		    this.shixindata=pageData.data
		    this.pageCount=pageData.pages
		    this.total=pageData.total
		    this.pageSize=pageData.size
		    this.currentPage=pageData.page
      }
    }
}
</script>

<style scoped>
  .table-box{
    background: white;
    padding-top: 10px;

  }
  .title{
    text-align: center;
    line-height: 50px;
  }

  .shixinren{
    width: 1000px;
    margin:20px auto;
  }
  .pagination{
    background: white;
    margin-top: 2px;
    padding:5px 0;
  }
</style>
